function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Add Circle Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M54,27 C54,12.0885638 41.9118566,-5.67879077e-14 27.0013086,-5.67879077e-14 C12.0894283,-5.67879077e-14 -5.68434189e-14,12.0885875 -5.68434189e-14,27 C-5.68434189e-14,41.9114125 12.0894283,54 27.0013086,54 C41.9118566,54 54,41.9114362 54,27 Z M51.9867198,27 C51.9867198,40.7995479 40.799937,51.9867198 27.0013086,51.9867198 C13.2013009,51.9867198 2.01328019,40.7994772 2.01328019,27 C2.01328019,13.2005228 13.2013009,2.01328019 27.0013086,2.01328019 C40.799937,2.01328019 51.9867198,13.2004521 51.9867198,27 Z",
  id: "add-circle-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "add-circle-Icon/Global/Membership/Add",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "add-circle-Swatches/Midnight"
}, /*#__PURE__*/React.createElement("use", {
  id: "add-circle-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#add-circle-path-1"
})), /*#__PURE__*/React.createElement("line", {
  x1: 13,
  y1: 27,
  x2: 41,
  y2: 27,
  id: "add-circle-Line",
  stroke: "currentcolor",
  strokeWidth: 2.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 13,
  y1: 27,
  x2: 41,
  y2: 27,
  id: "add-circle-Line-Copy",
  stroke: "currentcolor",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  transform: "translate(27.000000, 27.000000) rotate(90.000000) translate(-27.000000, -27.000000) "
}));

var SvgAddCircle = function SvgAddCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 54 54",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-circle.9e0f41bf.svg";
export { ForwardRef as ReactComponent };